// extracted by mini-css-extract-plugin
export default {"buttonPollForm":"ButtonForm_buttonPollForm__HEq98"};